import React from 'react';
import './style.css';
import food1 from '../images/food1.png';
import food2 from '../images/food2.png';

const DealOfTheWeek = () => {

  const phoneNumber = '918800864674'; // Your number here

  const handleClick = () => {
    window.open(`https://wa.me/${phoneNumber}`, '_blank');
  };

  return (
    <section className="deal-of-the-week">
      <h2>Deal Of The Week</h2>
       {/*<div className="timer">
        <div className="time-box">
          <span>10</span>
          <p>Days</p>
        </div>
        <div className="time-box">
          <span>19</span>
          <p>Hours</p>
        </div>
        <div className="time-box">
          <span>59</span>
          <p>Minutes</p>
        </div>
        <div className="time-box">
          <span>57</span>
          <p>Seconds</p>
        </div>
      </div> */}
      <div className="food-card-wrapper">
        <div className="food-card">
          <div className="food-image">
          <span className="sale-badge">Sale</span>
            <img src={food1} alt="Royal Canin" />
            
          </div>
          <div className="food-info">
            <h3>PURINA PRO PLAN® Adult Dog Food for Large Breed Dogs</h3>
            <p className="price">Rs.8,778</p>
            {/* <ul>
              <li>Adult dogs</li>
              <li>Dry food</li>
              <li>Joint Health</li>
            </ul> */}
            <button className="buy-now" onClick={handleClick} >Buy Now</button>
          </div>
        </div>
        <div className="food-card">
          <div className="food-image">
            <img src={food2} alt="Pedigree" />
          </div>
          <div className="food-info">
            <h3>PRO PLAN® All Life Stages All Size Performance Chicken - Dry Dog Food</h3>
            <p className="price">Rs.7,544</p>
            {/* <ul>
              <li>Expert Nutrition</li>
              <li>Boosts Immunity</li>
              <li>Pregnant/Lactating Mothers & Pups</li>
            </ul> */}
            <button className="buy-now" onClick={handleClick} >Buy Now</button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DealOfTheWeek;
